var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_2167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 0C2.78587 0 2.34075 0.184374 2.01256 0.512563C1.68437 0.840752 1.5 1.28587 1.5 1.75V10.25C1.5 10.7141 1.68437 11.1592 2.01256 11.4874C2.34075 11.8156 2.78587 12 3.25 12C3.71413 12 4.15925 11.8156 4.48744 11.4874C4.81563 11.1592 5 10.7141 5 10.25V1.75C5 1.28587 4.81563 0.840752 4.48744 0.512563C4.15925 0.184374 3.71413 0 3.25 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75012 0C8.28599 0 7.84087 0.184374 7.51269 0.512563C7.1845 0.840752 7.00012 1.28587 7.00012 1.75V10.25C7.00012 10.7141 7.1845 11.1592 7.51269 11.4874C7.84087 11.8156 8.28599 12 8.75012 12C9.21425 12 9.65937 11.8156 9.98756 11.4874C10.3157 11.1592 10.5001 10.7141 10.5001 10.25V1.75C10.5001 1.28587 10.3157 0.840752 9.98756 0.512563C9.65937 0.184374 9.21425 0 8.75012 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseFill);
export default __webpack_public_path__ + "static/media/pauseFill.13e1fc7b40d1e3625301245ad61bbd23.svg";
export { ForwardRef as ReactComponent };